import { FormGroup, Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button/Button';
import { icons } from '../../../generic/Icon/icons';
import { Icon } from '../../../generic/Icon/index';
import Loader from '../../../generic/Loader';

import useGetPlanUsage from './useGetPlanUsage';
import type { OrganizationPlanUsage } from './useGetPlanUsage';

import styles from './ModalFeaturesLost.module.less';

type ModalBodyProps = {
  onConfirm: () => void;
  onHide: () => void;
  planUsage: OrganizationPlanUsage;
};

const ModalBody: VoidFunctionComponent<ModalBodyProps> = ({
  onConfirm,
  onHide,
  planUsage,
}: ModalBodyProps) => {
  return (
    <>
      <p>
        You will lose these features you put to good use!
      </p>

      <ul className={styles.featureList}>
        <li>
          <span>
            <Icon icon={icons.copy} />{' '}
            Projects integrated with FOSSA
          </span>
          <span>
            { planUsage.projectCount }
          </span>
        </li>
        <li>
          <span>
            <Icon icon={icons.bug} />{' '}
            Issues solved with FOSSA
          </span>
          <span>
            { planUsage.solvedIssueCount }
          </span>
        </li>
        <li>
          <span>
            <Icon icon={icons.refresh} />{' '}
            Revisions over the past 3 months
          </span>
          <span>
            { planUsage.recentRevisionCount }
          </span>
        </li>
      </ul>

      <p>
        Plus all the other time-saving benefits of our Business Plan.
      </p>

      <FormGroup className={styles.actionButtons}>
        <Button
          onClick={onHide}
          size="medium"
          type="secondary"
        >
          Keep the Business Plan
        </Button>
        <Button
          onClick={onConfirm}
          size="medium"
          type="error"
        >
          Continue to downgrade
        </Button>
      </FormGroup>
    </>
  );
};

type ModalFeaturesLostProps = {
  onConfirm: () => void;
  onHide: () => void;
  isShowing: boolean;
};

const ModalFeaturesLost: VoidFunctionComponent<ModalFeaturesLostProps> = ({
  onConfirm,
  onHide,
  isShowing,
}: ModalFeaturesLostProps) => {
  const { data, isLoading } = useGetPlanUsage();

  return (
    <Modal
      show={isShowing}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Are you sure that you want to downgrade?</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        {
          isLoading || !data
            ? <Loader />
            : <ModalBody onConfirm={onConfirm} onHide={onHide} planUsage={data} />
        }

      </Modal.Body>
    </Modal>
  );
};

export default ModalFeaturesLost;
